import { render, staticRenderFns } from "./materialListView.vue?vue&type=template&id=64c731e4&scoped=true"
import script from "./materialListView.vue?vue&type=script&lang=js"
export * from "./materialListView.vue?vue&type=script&lang=js"
import style0 from "./materialListView.vue?vue&type=style&index=0&id=64c731e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c731e4",
  null
  
)

export default component.exports